import { render, staticRenderFns } from "./AcceptInvitation.vue?vue&type=template&id=66559248&scoped=true"
import script from "./AcceptInvitation.vue?vue&type=script&lang=js"
export * from "./AcceptInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66559248",
  null
  
)

export default component.exports